var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "414px",
    height: "414px",
    viewBox: "0 0 414 414",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets/Circles") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets/Circles",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#FAFAFA",
    strokeWidth: 2.05285863
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.28,
    cx: 207,
    cy: 207,
    r: 32.0861804
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.26,
    cx: 207,
    cy: 207,
    r: 41.806466
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.24,
    cx: 207,
    cy: 207,
    r: 51.5267516
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.22,
    cx: 207,
    cy: 207,
    r: 61.2367729
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.2,
    cx: 207,
    cy: 207,
    r: 70.9570586
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.18,
    cx: 207,
    cy: 207,
    r: 80.6773442
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.16,
    cx: 207,
    cy: 207,
    r: 90.3873655
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.14,
    cx: 207,
    cy: 207,
    r: 100.107651
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.12,
    cx: 207,
    cy: 207,
    r: 109.827937
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.1,
    cx: 207,
    cy: 207,
    r: 119.548222
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.09,
    cx: 207,
    cy: 207,
    r: 129.258244
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.08,
    cx: 207,
    cy: 207,
    r: 138.978529
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.07,
    cx: 207,
    cy: 207,
    r: 148.698815
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.06,
    cx: 207,
    cy: 207,
    r: 158.408836
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.05,
    cx: 207,
    cy: 207,
    r: 168.129122
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.04,
    cx: 207,
    cy: 207,
    r: 177.849407
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.03,
    cx: 207,
    cy: 207,
    r: 187.559429
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.02,
    cx: 207,
    cy: 207,
    r: 197.279714
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.01,
    cx: 207,
    cy: 207,
    r: 207
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/Circles.878acc9b6075a86d7cf24c5351b1f873.svg";
export { ForwardRef as ReactComponent };